module.exports = __webpack_public_path__ + "img/06_food4.d438cac9.png";